import { useAppSelector } from 'app/hooks';
import { useEffect, useState } from 'react';
import { ForecastDto } from 'types';
import {
  convertNumberFromDB,
  convertToImperial,
} from '../../weather/utils/dataConverters';
import { useForecast } from '../api/getForecast';

export const useFormatForecastData = (
  locationId: number | undefined | null
) => {
  const useImperial = useAppSelector(
    (state) => state.auth.user?.us_customary_units
  );
  const { isLoading, data: rawForecast } = useForecast({ locationId });
  const [formattedForecast, setFormattedForecast] = useState<
    ForecastDto | undefined
  >(undefined);

  useEffect(() => {
    if (isLoading || !rawForecast) return;

    const newConvertedWeatherData: ForecastDto = {
      locationId: rawForecast.locationId,
      dailyForecast: [],
      hourlyForecast: [],
    };
    for (const dailyDatum of rawForecast.dailyForecast) {
      const convertedDatum = {
        ...dailyDatum,
        maxtemp_c: convertNumberFromDB(
          convertToImperial(dailyDatum.maxtemp_c, 'maxtemp_c', useImperial),
          'maxtemp_c'
        ),
        mintemp_c: convertNumberFromDB(
          convertToImperial(dailyDatum.mintemp_c, 'mintemp_c', useImperial),
          'mintemp_c'
        ),
        maxwind_kph: convertNumberFromDB(
          convertToImperial(dailyDatum.maxwind_kph, 'maxwind_kph', useImperial),
          'maxwind_kph'
        ),
        totalprecip_mm: convertNumberFromDB(
          convertToImperial(
            dailyDatum.totalprecip_mm,
            'totalprecip_mm',
            useImperial
          ),
          'totalprecip_mm'
        ),
      };
      newConvertedWeatherData.dailyForecast.push(convertedDatum);
    }
    newConvertedWeatherData.hourlyForecast = rawForecast.hourlyForecast;
    setFormattedForecast(newConvertedWeatherData);
  }, [isLoading, rawForecast, useImperial]);

  return { formattedForecast, isLoading };
};
